import React from "react";
import { useSelector } from "react-redux";
import PlayIcon from "../assets/play-arrow.svg";

export const VideoInfo = () => {
  const movie = useSelector((state) => state?.movies?.mainMovie);
  if (movie === undefined || movie === null) return;
  const { title, overview } = movie;
  return (
    <div className="hidden md:block absolute w-screen aspect-video pt-[32%] lg:pt-[36%] px-3 text-white bg-gradient-to-b from-slate-800 ">
      <h1 className="py-2 font-bold text-2xl">{title}</h1>
      <p className="hidden md:block pb-6 text-xs md:w-full lg:w-4/5 ">
        {overview}
      </p>
      <div className="flex justify-start">
        <button className=" mx-1 w-20 h-8 bg-white rounded-md bg-opacity-90 hover:opacity-80">
          <div className="flex justify-center">
            <img className="w-4" src={PlayIcon} alt="play-icon" />
            <div className="text-xs text-black font-semibold">Play</div>
          </div>
        </button>
        <button className="w-20 h-8 bg-slate-700 text-white rounded-md bg-opacity-60 hover:opacity-80">
          <div>More Info</div>
        </button>
      </div>
    </div>
  );
};
